/* /tilbud – Kvitebergs tilbud til Proxima Hydrotech som en offentlig side (uten innlogging). Norsk. */
import { PROXIMA_NO } from "../data/tilbod/proxima";
import { ProductProposal } from "../components/proposal/ProductProposal";
import "../proposal.css";

export default function TilbudProposalPage() {
  return <ProductProposal d={PROXIMA_NO} />;
}
